import usePlanos from './usePlanos'
import styles from './styles.module.css'
import PlanoCard from './PlanoCard'
import LoadingBox from '../LoadingBox'
import Button from '../../../components/Button'
import Box from '../../../components/Box'
import { FiArrowLeft, FiArrowRight } from 'react-icons/fi'
import { useState } from 'react'

function Planos ({ dataManager, onNext, onBack }) {
  const { data, setData } = dataManager
  const { isLoading, filteredPlans } = usePlanos(data.segmento, data.credito)
  const [selectedPlanIdx, setSelectedPlanIdx] = useState(null)

  const handleActiveCard = idx => {
    setSelectedPlanIdx(selectedPlanIdx =>
      selectedPlanIdx === idx ? null : idx
    )
  }

  if (isLoading) {
    return <LoadingBox />
  }

  async function handleSubmit () {
    await setData({ ...data, plano: filteredPlans[selectedPlanIdx] })
    onNext()
  }

  return (
    <Box className={styles.bemBox}>
      <h3>Escolha um dos planos disponíveis</h3>
      <h4>
        Selecionamos a opção de crédito ideal para você! Agora, é a sua vez de
        optar pelo plano que melhor se adequa a esse crédito e a você!.
      </h4>
      <ul className={styles.bensContainer}>
        {filteredPlans?.map((plano, idx) => (
          <PlanoCard
            active={selectedPlanIdx === idx}
            codigoGrupo={plano.grupo.codigoGrupo}
            vagasGrupo={plano.grupo.quantidadeVagas}
            nParcelas={plano.grupo.quantidadeMesesPrazo}
            valorParcela={(plano.grupo.valorParcela * data.multiple).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
            menorLance={(plano.menorLanceContemplacao.valor / data.credito.valorBem) * 100}
            key={idx}
            onClick={() => handleActiveCard(idx)}
          />
        ))}
      </ul>
      <div className={styles.buttons}>
        <Button outline onClick={onBack}>
          <FiArrowLeft style={{ strokeWidth: 3 }} />
          Voltar
        </Button>
        <Button disabled={selectedPlanIdx === null} onClick={handleSubmit}>
          Continuar
          <FiArrowRight style={{ strokeWidth: 3 }} />
        </Button>
      </div>
    </Box>
  )
}
export default Planos
